import HttpClientApiKey from '../../services/HttpClientApiKey';
import HttpClientToken from '../../services/HttpClientToken';

import { AxiosError } from 'axios';

import { defaultHttpResponse, defaultVersionResponse, EntrarComoParams, EnviarCodigoVerificacionParams, HttpResponse, LoginParams, LoginResponse, ValidarCodigoVerificacionParams, ValidarFirmaElectronicaResponse, VersionResponse } from '../../interfaces/auth/AuthInterface';

export const Login = ( params: LoginParams ) => {

    return new Promise<LoginResponse>( ( resolve ) => {

        HttpClientApiKey.post('/Api/Auth/Login', params)
        .then( ({ data } : { data : LoginResponse } ) => {
            resolve( data );
        })
        .catch( ( error: AxiosError ) => {
            resolve( { ...defaultHttpResponse, message: error.message } );
        });

    });

}

export const EnviarCodigoVerificacion = ( params: EnviarCodigoVerificacionParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        HttpClientApiKey.post('/Api/Auth/EnviarCodigoVerificacion', params)
        .then( ({ data } : { data : HttpResponse } ) => {
            resolve( data );
        })
        .catch( ( error: AxiosError ) => {
            resolve( { ...defaultHttpResponse, message: error.message } );
        });

    });

}

export const ValidarCodigoVerificacion = ( params: ValidarCodigoVerificacionParams ) => {

    return new Promise<LoginResponse>( ( resolve ) => {

        HttpClientApiKey.post('/Api/Auth/ValidarCodigoVerificacion', params)
        .then( ({ data } : { data : LoginResponse } ) => {
            resolve( data );
        })
        .catch( ( error: AxiosError ) => {
            resolve( { ...defaultHttpResponse, message: error.message } );
        });

    });

}

export const EntrarComo = ( params: EntrarComoParams ) => {

    return new Promise<LoginResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Auth/EntrarComo', params, token)
            .then( ({ data } : { data : LoginResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const Logout = () => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Auth/Logout/', null, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const ValidarToken = () => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Auth/ValidarToken/', null, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const ObtenerVersion = () => {

    return new Promise<VersionResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Auth/ObtenerVersion/', token)
            .then( ({ data } : { data : VersionResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultVersionResponse, message: error.message } );
            });

        }

    });

}

export const ValidarFirmaElectronica = () => {

    return new Promise<ValidarFirmaElectronicaResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Auth/ValidarFirmaElectronica/', null, token)
            .then( ({ data } : { data : ValidarFirmaElectronicaResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}
